/* eslint-disable react/no-array-index-key */
import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { pipe, filter, complement, propEq } from 'ramda';

import { useAsyncState } from 'utils/useAsyncState';
import { ID, FILE, FORM } from 'store/planning';
import ImagesReview from 'components/ImagesReview';
import Spinner from 'components/FullScreenSpinner';

import Item from './Item';
import { Container, ReadModeWrapper, NoDocuments, WaitItem, SpinnerWrap, Label } from './styles';

const MultiImage = ({ values, waiting, updateValues }) => {
  const [imagePath, setImagePath] = useAsyncState();
  const files = useMemo(() => values.map(({ [FILE]: file }) => file), [values]);
  const closeFile = useCallback(() => setImagePath(), [setImagePath]);

  const removeMedia = useCallback((id) => pipe(filter(complement(propEq(id, ID))), updateValues)(values), [updateValues, values]);

  if (values.length === 0 && waiting.length === 0) {
    return (
      <ReadModeWrapper>
        <NoDocuments>Noch keine Dokumente vorhanden</NoDocuments>
      </ReadModeWrapper>
    );
  }

  return (
    <Container>
      {values.map(({ [ID]: id, [FILE]: fileData, [FORM]: form }) => (
        <Item key={id} id={id} fileData={fileData} form={form} setImagePath={setImagePath} removeMedia={removeMedia} />
      ))}
      {waiting.map((name, i) => (
        <WaitItem key={name + i}>
          <SpinnerWrap>
            <Spinner height="100%" />
          </SpinnerWrap>
          <Label>{name}</Label>
        </WaitItem>
      ))}
      {imagePath && <ImagesReview currentImage={imagePath} images={files} onClose={closeFile} />}
    </Container>
  );
};

MultiImage.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      [ID]: PropTypes.string,
      destination: PropTypes.string,
      path: PropTypes.string,
      previewname: PropTypes.string,
      originalname: PropTypes.string,
      mimetype: PropTypes.string,
    })
  ).isRequired,
  waiting: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  updateValues: PropTypes.func.isRequired,
};

export default MultiImage;
